import {
  IManualExtendedData,
  isManualExtendedData,
  TransactionType,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../transaction-action';
import {
  getRefundInfo$,
  getRefundLabel$,
  getRefundRemaining$,
} from '../../transaction-helpers';
import { ManualTransactionProvider } from '../manual-transaction-provider.service';

export class RefundManualTransaction
  implements ITransactionAction<IManualExtendedData>
{
  icon = 'undo';
  label = 'Refund';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isManualExtendedData;

  constructor(private _provider: ManualTransactionProvider) {}

  canDo$(
    data: ITransactionActionsData<IManualExtendedData>
  ): Observable<boolean> {
    return getRefundRemaining$(data).pipe(
      map((remaining) => {
        const isIncoming = data.transaction.type === TransactionType.Incoming;
        const hasRemaining = remaining > 0;
        return isIncoming && hasRemaining;
      })
    );
  }

  label$(
    data: ITransactionActionsData<IManualExtendedData>
  ): Observable<string> {
    return getRefundLabel$(data);
  }

  info$(
    data: ITransactionActionsData<IManualExtendedData>
  ): Observable<string[]> {
    return getRefundInfo$(data);
  }

  async do(data: ITransactionActionsData<IManualExtendedData>): Promise<void> {
    this.inProgress$.next(true);
    await this._provider.refundTransaction(
      data.invoice,
      data.latestTransaction
    );
    this.inProgress$.next(false);
  }
}
